import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export interface IGeneralState {
  refreshedTimestamp?: number; // When we updated them
  status: string;
  error?: string;
}

export type GeneralState = IGeneralState;

export type UpdateGeneralArgs = {
  refreshedTimestamp?: number; // When we updated them
};

const initialState: GeneralState = {
  refreshedTimestamp: undefined,
  status: "idle",
  error: undefined,
};

export const generalSlice = createSlice({
  name: "store",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(updateGeneral.pending, (state) => {})
      .addCase(updateGeneral.fulfilled, (state, action) => {
        console.log("STORE - updateGeneral.fulfilled", action.payload);
        const update: UpdateGeneralArgs = action.payload;
        state.refreshedTimestamp = update.refreshedTimestamp;
      })
      .addCase(updateGeneral.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        console.error("updateStore.rejected", state, action);
      });
  },
});

export const updateGeneral = createAsyncThunk("store/updateGeneral", async (args: UpdateGeneralArgs) => {
  console.log("STORE - updateGeneral", args);
  return args;
});

// Action creators are generated for each case reducer function

export const {} = generalSlice.actions;

export default generalSlice.reducer;
